// Options for the social-link icon picker. The value is the icon class string stored on the link.
// `translate: true` marks labels that are i18n keys rather than brand names.
const ICON_OPTIONS = [
  { value: "fa-brands fa-facebook  text-blue-600", label: "Facebook" },
  { value: "fab fa-instagram text-pink-600", label: "Instagram" },
  { value: "fab fa-tiktok text-black", label: "Tiktok" },
  { value: "fa-brands fa-square-youtube text-red-600", label: "Youtube" },
  { value: "fa-brands fa-snapchat text-yellow-500", label: "Snapchat" },
  { value: "fa-solid fa-globe", label: "Website", translate: true },
  { value: "fab fa-linkedin text-blue-600", label: "Linkedin" },
  { value: "fa-brands fa-telegram text-blue-400", label: "Telegram" },
  { value: "fab fa-whatsapp text-green-400", label: "whatsapp" },
  { value: "fab fa-twitter text-blue-400", label: "Twitter" },
  { value: "fab fa-viber text-purple-400", label: "Viber" },
  { value: "tell fa-solid fa-phone text-green-400", label: "Call", translate: true },
  { value: "fab fa-behance text-black", label: "Behance" },
  { value: "fab fa-github text-black", label: "Github" },
  { value: "fa-solid fa-link text-black", label: "Other", translate: true },
];

export default ICON_OPTIONS;
